import styled from "styled-components/macro";

export const WorkflowList = styled.ul`
  width: 100%;
  display: flex;
  border-top: 1px solid #B4B4B4;
    
  @media (max-width: 979px) {
    flex-direction: column;
    border: none;
    gap: 52px;
    margin-top: 26px;
  }
`

export const WorkflowItem = styled.li`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 26px;

    &:not(:last-child) {
      border-right: 1px solid rgb(180, 180, 180);

      @media (max-width: 979px) {
        border: none;
      }
    }

    @media (max-width: 979px) {
      padding: 0 8px;
      gap: 6px;
      align-items: center;
    }
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
    
  @media (max-width: 979px) {
    width: 100%;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
    margin-bottom: 16px;
  }
`

export const NumberBlock = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 18px;
    
  @media (max-width: 979px) {
    margin-bottom: 0;
  }
`

export const Circle = styled.div<{color: string}>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${({ color }) => color};
`

export const Number  = styled.span`
  font-size: 18px;
  line-height: 140%;
`

export const TitleBlock = styled.div`
  display: flex;
  flex-direction: column;
    
  @media (max-width: 979px) {
    flex-direction: row;
  }
`

export const Title = styled.span`
  font-family: "Cormorant Infant", sans-serif;
  font-weight: 600;
  line-height: 86%;
  font-size: 40px;
    
  @media (max-width: 1439px) {
    font-size: 35px;
  }

  @media (max-width: 979px) {
    font-size: 30px;
    margin-right: 5px;
  }
`

export const TitleColored = styled(Title)`
  color: #55749F;
`

export const Desc = styled.span`
  font-size: 18px;
  line-height: 140%;
  
  @media (max-width: 979px) {
    text-align: left;
    font-size: 15px;
  }
`
